<span
  *ngIf="!isSmallDisplaySize"
  pTooltip="{{ htmlText }}"
  tooltipPosition="{{ tooltipPosition }}"
  hideDelay="{{ hideDelay }}"
  tooltipStyleClass="{{ class }}"
  [escape]="false"
>
  <span *ngIf="!noIcon" class="icon icon-help"> </span>
  <span *ngIf="extraTitle" [ngClass]="extraTitleClass"> {{ extraTitle }} </span>
</span>

<span *ngIf="isSmallDisplaySize" (click)="showTooltip()">
  <span *ngIf="!noIcon" class="icon icon-help"> </span>
  <span *ngIf="extraTitle" [ngClass]="extraTitleClass"> {{ extraTitle }} </span>
</span>
